import { Vue as _Vue } from 'vue/types/vue'
import { VueModule } from 'vue-modules'
import VueRouter from 'vue-router'
import { Store } from 'vuex'
import { createChatBotRoutes } from './router/chatbot-router'
import { ChatStore } from '@/modules/chatbot/store'

export class ChatbotModule implements VueModule {
  public readonly name = 'chatbot';
  constructor (private router: VueRouter, private store: Store<any>) {}

  public install (Vue: typeof _Vue) {
    const routes = createChatBotRoutes(this.store)
    this.router.addRoutes(routes)
    this.store.registerModule('chat', ChatStore)
  }
}
